import Container from '../Container'
import type ExperienceData from '../../types/experience'
import { getAssetUrl } from '../../utils'
import { useEffect, useState } from 'react'
import { audio } from '../../utils/audio'
import type { IntroPanel } from '../../types/panel'
import { ASSETS } from '../../assets'

interface Props {
  mode: 'driver' | 'engineer'
  experience: ExperienceData
  onStart: () => void
}
export default function HomePanel({ mode, experience, onStart }: Props) {
  const background = experience.colours?.exploreLeftPanelBackground || '#002D9C'
  const [logo, setLogo] = useState(ASSETS.ibm)
  const [panelData, setPanelData] = useState<IntroPanel>({} as IntroPanel)

  useEffect(() => {
    setLogo(
      experience.brandLogo
        ? experience.brandLogo.url.startsWith('blob:')
          ? experience.brandLogo.url
          : getAssetUrl(experience.brandLogo.filename)
        : ASSETS.ibm
    )
    setPanelData(
      mode === 'engineer' ? experience.engineerMode.homePanel : experience.driverMode.homePanel
    )
  }, [mode, experience])
  return (
    <Container>
      <div className="absolute inset-0 flex h-full w-full py-[61px] pl-[66px]">
        <div
          className="bg-blue flex h-full w-[537px] shrink-0 flex-col justify-between px-10 py-[45.87px]"
          style={{ background: `${background}` }}
        >
          <div className="flex flex-col gap-16">
            <div className="flex items-center justify-between">
              <img src={logo} width={118} height={44} />
              <span className="block max-w-2/5 text-[23px] leading-[30px] font-light">
                {experience.slogan || 'watsonx. Your AI Race Engineer'}
              </span>
            </div>
            <h1 className="text-[60px] leading-[60px] font-light">
              {(panelData?.title || (mode === 'engineer' ? 'Welcome Engineer' : 'Welcome Driver'))
                .split(' ')
                .map((word, i) => (
                  <span key={i} className="block">
                    {word}
                  </span>
                ))}
            </h1>
            <p className="text-[20px] leading-[27px] font-light opacity-100">{panelData?.body}</p>
          </div>
          <div className="flex flex-col gap-[106px]">
            <div className="flex items-center gap-[33px]">
              <div
                className="bg-blue-tint-3 flex flex-shrink-0 items-center justify-center rounded-full"
                style={{ width: 83, height: 83 }}
              >
                <img
                  src={
                    panelData?.instructionIcon
                      ? panelData.instructionIcon.url.startsWith('blob:')
                        ? panelData.instructionIcon.url
                        : getAssetUrl(panelData.instructionIcon.filename)
                      : ASSETS.iconHeadphones
                  }
                  width={46}
                  height={46}
                />
              </div>
              <span className="w-1/2 text-[20px] leading-[27px] font-light">
                {panelData?.instructionText}
              </span>
            </div>
            <button
              className="bg-blue-tint-3 hover:bg-blue-tint-5 hover:text-blue active:bg-blue-tint-5 active:text-blue flex w-[222px] items-center justify-between px-6 py-3 text-left text-[20px] leading-[27px] font-light hover:cursor-pointer"
              onClick={() => {
                const sfx = experience.soundEffects?.mainButton
                if (sfx) {
                  const url = sfx.url.startsWith('data:') ? sfx.url : getAssetUrl(sfx.filename)
                  if (url) {
                    audio.register({ mainButton: url })
                    audio.play('mainButton')
                  }
                }
                onStart()
              }}
            >
              <span>{panelData?.startCtaLabel || 'Tap to Start'}</span>
              <img src={ASSETS.iconArrowRight} width={24} height={15} />
            </button>
          </div>
        </div>
      </div>
    </Container>
  )
}
